import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  Text,
  Skeleton,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";
import {useHistory } from "react-router-dom";
import {
  FaHeart,
  FaUser,
  FaArchive,
  // FaAdjust,
  // FaRegNewspaper,
  FaExclamationTriangle,
  FaUserTie,
} from "react-icons/fa";
import { useAuth, logout } from "../../auth";
import { useGoogleAuth } from "../common/google/GoogleAuthContext";
import { useUser } from "../userRole/UserContext";
import { useOTP } from "../AdminPanelAccess/OTPContext";
import SidebarItem from "./SidebarItem";
import { FaSuitcase, FaWallet } from "react-icons/fa";
import { ReactComponent as HomeIcon } from "../../assets/icons/home_house_icon.svg";
import { ReactComponent as ChatIcon } from "../../assets/icons/chat_fill_message_communication_icon.svg";
import { ReactComponent as TravelTrackerIcon } from "../../assets/icons/passport.svg";
// import { ReactComponent as PackingListIcon } from "../../assets/icons/fluent_clipboard_task_list_icon.svg";
// import { ReactComponent as BudgetPlannerIcon } from "../../assets/icons/budget.svg";
import { ReactComponent as ItineraryIcon } from "../../assets/icons/noun-travel-itinerary-4236219.svg";
import { ReactComponent as DonateIcon } from "../../assets/icons/donate.svg";
import Translate from "../LanguageTranslation/Translate";
import SidebarHeader from "./SidebarHeader";
import SidebarFooter from "./SidebarFooter";
import BaseScreenMenu from "./BaseScreenMenu";

import { pendingInvitesCount } from "../../api/invites";

function SideBar() {
  const { colorMode} = useColorMode();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isAuthModalOpen,
    onOpen: onAuthModalOpen,
    onClose: onAuthModalClose,
  } = useDisclosure();
  const history = useHistory();
  const [logged] = useAuth();
  const { resetOTP } = useOTP();
  const { authState } = useGoogleAuth();
  const { user, loading } = useUser();
  const [redirectPath, setRedirectPath] = useState("/ai-travel-planner");
  const [badge, setBadge] = useState(0);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const isUserLoggedIn = logged || authState.isLoggedIn;

  const username = localStorage.getItem("username") || "";
  const email = localStorage.getItem("email") || "unknown@example.com";

  const refreshBadge = async () => {
    try {
      const { data } = await pendingInvitesCount();
      setBadge(data.data.count);
    } catch {
      setBadge(0);
    }
  };
  useEffect(() => {
    refreshBadge();
  }, []);

  const logoutAndClear = () => {
    logout();
    const keysToRemove = [
      "username",
      "email",
      "perPage",
      "perPageFilter",
      "nPXg",
      "chat_messages",
      "conversation_id",
      "OTP_TOKEN",
      "profilepic",
      "selectedTab",
      "selectedTripPackingList",
      "selectedTripBudgetPlanner",
      "tripNameBudgetPlanner",
      "expenses",
      "totalBudgetBudgetPlanner",
      "generalInfoAdded",
      "activeTab",
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    resetOTP();
    history.push("/home");
  };

  const role = user ? user.role : null;

  let navLinks = [];

  const openAuthModal = (redirectPath) => {
    onAuthModalOpen();
    setRedirectPath(redirectPath);
  };

  // Renders "Bucket List" with an optional green badge
  const bucketLabel = () => (
    <Box position="relative" display="inline-block">
      <Text display="inline">
        <Translate text="Bucket List" />
      </Text>

      {badge > 0 && (
        <Box
          position="absolute"
          top="-6px"
          right="-16px"
          bg="#286328"
          color="white"
          fontWeight="bold"
          fontSize="10px"
          lineHeight="16px"
          w="16px"
          h="16px"
          borderRadius="full"
          textAlign="center"
        >
          {badge}
        </Box>
      )}
    </Box>
  );

  if (loading) {
    navLinks = [
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
      { to: "#", text: <Skeleton width="100px" height="20px" /> },
    ];
  } else if (isUserLoggedIn) {
    navLinks.push({
      to: "/ai-travel-planner",
      text: "Ask Ava",
      icon: HomeIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/chat",
      text: "Chat",
      icon: ChatIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/bucket-list",
      text: bucketLabel(), // <-- was plain string before
      icon: FaHeart,
      ...(isUserLoggedIn
        ? {} // nothing extra for logged-in
        : { onClick: () => openAuthModal("/ai-travel-planner/bucket-list") }),
    });

    navLinks.push({
      to: "/ai-travel-planner/ongoing-trip",
      text: "Ongoing Trip",
      icon: ItineraryIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/budget-planner",
      text: "Budget Planner",
      icon: FaWallet,
    });
    navLinks.push({
      to: "/ai-travel-planner/packing-list",
      text: "Packing List",
      icon: FaSuitcase,
    });
    navLinks.push({
      to: "/ai-travel-planner/travel-feed",
      text: (
        <Box position="relative" display="inline-block" width="auto">
          <Text display="inline">
            <Translate text="Travel Feed" />
          </Text>
          <Box
            position="absolute"
            top={-3} // Adjust to move "Beta" slightly above
            right={-10} // Adjust for horizontal position
            bg="blackAlpha.100" // Similar to the pink color in the image
            color="black"
            fontWeight="bold"
            fontSize="10px"
            px={2}
            py={0.5}
            borderRadius="lg"
            display="inline"
          >
            <Translate text="SOON" />
          </Box>
        </Box>
      ),
      icon: TravelTrackerIcon,
    });
  } else {
    navLinks.push({
      to: "/ai-travel-planner",
      text: "Ask Ava",
      icon: HomeIcon,
    });
    navLinks.push({
      to: "/ai-travel-planner/chat",
      text: "Chat",
      icon: ChatIcon,
    });

    navLinks.push({
      to: "/ai-travel-planner/bucket-list",
      text: "Bucket List",
      icon: FaHeart,
    });
    navLinks.push({
      to: "/ai-travel-planner/ongoing-trip",
      text: "Ongoing Trip",
      icon: ItineraryIcon,
      onClick: () => openAuthModal("/ai-travel-planner/ongoing-trip"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/budget-planner",
      text: "Budget Planner",
      icon: FaWallet,
      onClick: () => openAuthModal("/ai-travel-planner/budget-planner"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/packing-list",
      text: "Packing List",
      icon: FaSuitcase,
      onClick: () => openAuthModal("/ai-travel-planner/packing-list"), // Open auth modal for non-authenticated users
    });
    navLinks.push({
      to: "/ai-travel-planner/travel-feed",
      text: (
        <Box
          position="relative"
          display="inline-block"
          width="auto"
          onClick={() => openAuthModal("/ai-travel-planner/travel-feed")} // Corrected onClick syntax
        >
          <Text display="inline">
            <Translate text="Travel Feed" />
          </Text>
          <Box
              position="absolute"
            top={-3} // Adjust to move "Beta" slightly above
            right={-10} // Adjust for horizontal position
            bg="blackAlpha.100" // Similar to the pink color in the image
            color="black"
            fontWeight="bold"
            fontSize="10px"
            px={2}
            py={0.5}
            borderRadius="lg"
            display="inline"
          >
            <Translate text="SOON" />
          </Box>
        </Box>
      ),
      icon: TravelTrackerIcon,
    });
  }

  const popoverLinks = isUserLoggedIn
    ? [
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [{ to: "/account-settings", text: "My Account", icon: FaUser }]
          : []),
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [
              {
                to: "/archive",
                text: "Archiving and Downloading",
                icon: FaArchive,
              },
            ]
          : []),
        // ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
        //   ? [
        //       {
        //         to: "/switch-appearance",
        //         text: "Switch Appearance",
        //         icon: FaAdjust,
        //       },
        //     ]
        //   : []),
        // ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
        //   ? [
        //       {
        //         to: "/subscriptions",
        //         text: "Subscriptions",
        //         icon: FaRegNewspaper,
        //       },
        //     ]
        //   : []),
        ...(role === "Admin" || role === "User" || role === "Creator" || role === "Business"
          ? [
              {
                to: "/report",
                text: "Report a Problem",
                icon: FaExclamationTriangle,
              },
            ]
          : []),
        ...(role === "Admin"
          ? [
              {
                to: "/admin/dashboard",
                text: "Admin Dashboard",
                icon: FaUserTie,
              },
            ]
          : []),
      ]
    : [];

  return (
    <>
      <Box
        display={{ base: "none", lg: "flex" }}
        width={isSidebarOpen ? "17vw" : "5vw"}
        h="100vh"
        bg={colorMode === "dark" ? "gray.800" : "white"}
        color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
        borderRight="1px"
        borderColor="blackAlpha.200"
        flexDirection="column"
      >
        <SidebarHeader
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <Box
          flex="1"
          pl={0}
          pt={isSidebarOpen ? 8 : 8}
          overflowY="auto"
        >
          <List spacing={isSidebarOpen ? "4" : "4"} pl={isSidebarOpen ? 0 : 0}>
            {navLinks.map((link, index) => (
              <SidebarItem
                key={index}
                icon={link.icon}
                to={link.to}
                label={link.text}
                isOpen={isSidebarOpen}
                ml={isSidebarOpen ? 5 : 3}
                onClick={link.onClick}
              />
            ))}
            {/* Add Donate link here, only visible when sidebar is closed */}
            {!isSidebarOpen && (
              <SidebarItem
                icon={DonateIcon}
                to="/offset-your-carbon-footprint"
                label="Contribute"
                isOpen={isSidebarOpen}
                ml={3}
                onClick={
                  isUserLoggedIn
                    ? null
                    : () => openAuthModal("/offset-your-carbon-footprint")
                }
              />
            )}
          </List>
        </Box>

        <SidebarFooter
          logoutAndClear={logoutAndClear}
          isUserLoggedIn={isUserLoggedIn}
          isSidebarOpen={isSidebarOpen}
          username={username}
          email={email}
          colorMode={colorMode}
          popoverLinks={popoverLinks}
          openAuthModal={openAuthModal}
          redirectPath={redirectPath}
          isOpen={isAuthModalOpen}
          onClose={onAuthModalClose}
        />
      </Box>

      <BaseScreenMenu
        colorMode={colorMode}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        navLinks={navLinks}
        popoverLinks={popoverLinks}
        isSidebarOpen={isSidebarOpen}
        logoutAndClear={logoutAndClear}
      />
    </>
  );
}

export default SideBar;
